import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from '../../core/models/user';
import { OldDataService } from 'src/app/core/services/old-data.service';
import Swal from 'sweetalert2';
import { getFirebaseBackend } from 'src/app/authUtils';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { UserService } from 'src/app/services/user/user.service';
import { BlackoutdayService } from 'src/app/services/blackoutday/blackoutday.service';
import * as dayjs from 'dayjs';


@Component({
	selector: 'app-black-out-days',
	templateUrl: './black-out-days.component.html',
	styleUrls: ['./black-out-days.component.scss'],
})
export class BlackOutDaysComponent implements OnInit {
	public activeTab: string;
	public user: User;
	public newBlackOutDay = {
		user_id: 0,
		initial_date_hour: '',
		end_date_hour: '',
		reason: '',
		status: 'Pending',
		initial_hour: '',
		initial_min: '',
		end_hour: '',
		end_min: '',
		initial_ampm: '',
		end_ampm: '',
		recurrent: null,
	};

	public recurrent = {
		status: false,
		weekly: false,
		monthly: false,
		howManyTimes: 0,
	};

	public allAlias: any[];

	public dateBlackFrom = {
		year: 2020,
		month: 1,
		day: 1,
	};
	public dateBlackTo = {
		year: new Date().getFullYear(),
		month: new Date().getMonth() + 1,
		day: new Date().getDate(),
	};

	public blackStatus: string;
	public blackOutDays: any[];
	public historyActive: boolean;
	public historyBOD = [];

	public notification = {
		mainNotify: false,
		blackoutdays: false,
		rescheduleLeads: false,
	};

	public historyBlack = {
		login: '',
		initial_date_hour: '',
		end_date_hour: '',
		reason: '',
		status: '',
	};

	public showInactiveUsers = false;
	public allDay = false;

	constructor(
		private modalService: NgbModal,
		public authenticationService: AuthenticationService,
		public utils: UtilsService,
		private dataService: OldDataService,
		private userSrv: UserService,
				public blackOutSrv: BlackoutdayService,
		private cd: ChangeDetectorRef,
	) {
		this.blackStatus = 'Pending';
		this.historyActive = false;
		this.user = getFirebaseBackend()?.getAuthenticatedUser();

		const dateMothBefore = dayjs().subtract(1, 'month');
		this.dateBlackFrom = {
			year: dateMothBefore.year(),
			month: dateMothBefore.month() + 1,
			day: dateMothBefore.date(),
		};
	}

	ngOnInit() {
		this.activeTab = 'blackoutdays';
		this.getBlackOutDays();
	}

	getAllAlias() {
		this.userSrv.getAllAlias().subscribe((data:any)=>{
			this.allAlias = data.body;
		});
	}

	adminSaveBODay() {
		if (this.allDay) {
			this.newBlackOutDay.initial_hour = '00';
			this.newBlackOutDay.initial_min = '00';
			this.newBlackOutDay.initial_ampm = 'AM';
			this.newBlackOutDay.end_hour = '11';
			this.newBlackOutDay.end_min = '59';
			this.newBlackOutDay.end_ampm = 'PM';
			if (!this.newBlackOutDay.end_date_hour) {
				this.newBlackOutDay.end_date_hour = this.newBlackOutDay.initial_date_hour;
			}
		}
		if (
			this.newBlackOutDay.initial_date_hour != '' &&
			this.newBlackOutDay.initial_hour != '' &&
			this.newBlackOutDay.initial_min != '' &&
			this.newBlackOutDay.end_date_hour != '' &&
			this.newBlackOutDay.end_hour != '' &&
			this.newBlackOutDay.end_min != '' &&
			this.newBlackOutDay.user_id != 0 &&
			this.newBlackOutDay.initial_ampm != '' &&
			this.newBlackOutDay.end_ampm != ''
		) {
			let initial_time = this.utils.time12To24(
				`${this.newBlackOutDay.initial_hour}:${this.newBlackOutDay.initial_min} ${this.newBlackOutDay.initial_ampm}`,
			);
			let end_time = this.utils.time12To24(
				`${this.newBlackOutDay.end_hour}:${this.newBlackOutDay.end_min} ${this.newBlackOutDay.end_ampm}`,
			);
			this.newBlackOutDay.initial_date_hour =
				this.datePickerToPHP(this.newBlackOutDay.initial_date_hour) +
				' ' +
				initial_time;
			this.newBlackOutDay.end_date_hour =
				this.datePickerToPHP(this.newBlackOutDay.end_date_hour) +
				' ' +
				end_time;

			this.newBlackOutDay.recurrent;

			this.blackOutSrv.saveBlackOutDay(this.newBlackOutDay).subscribe((data:any)=>{
				this.getBlackOutDays();
				this.recurrent.howManyTimes = 0;
				this.recurrent.status = false;
				this.recurrent.weekly = false;
				this.recurrent.monthly = false;
				this.newBlackOutDay.recurrent = null;
				Swal.fire({
					title: 'Success',
					text: 'Black Out Day Saved!',

					confirmButtonText: 'Ok',
				});
			});
		} else {
			Swal.fire({
				title: 'Error',
				text: 'Fill all fields',

				confirmButtonText: 'Ok',
			});
		}
	}

	// TODO: PASAR A UTILS
	datePickerToPHP(date: any) {
		let mes = '';
		let dia = '';

		if (date.month < 10) {
			mes = '0' + date.month;
		} else {
			mes = date.month;
		}

		if (date.day < 10) {
			dia = '0' + date.day;
		} else {
			dia = date.day;
		}
		return date.year + '-' + mes + '-' + dia;
	}

	getBlackOutDays() {
		const payload = {
			status: this.blackStatus,
			inactive_users: this.showInactiveUsers,
		};
		this.blackOutDays = [];
		this.blackOutSrv.getBlackOutDays(payload).subscribe((data:any)=>{
			this.blackOutDays = data.body;
			this.cd.detectChanges();
		});
	}

	// PASAR A UTILS
	badgeStatus(status: any) {
		switch (status) {
			case 'Approved':
				return 'bg-success';
				break;
			case 'Denied':
				return 'bg-danger';
				break;
			case 'Pending':
				return 'badge-soft-secondary';
				break;
			default:
				break;
		}
		return '';
	}

	changeBlackOutDayStatus(blackoutday: any, status = '') {
		blackoutday = {... blackoutday};
		if(status !== ''){
			blackoutday.status = status;
		} else {
			if (blackoutday.status === 'Approved') {
				blackoutday.status = 'Denied';
			} else if (blackoutday.status === 'Denied') {
				blackoutday.status = 'Approved';
			}
		}
		const payload = {
			id: blackoutday.id,
			status: blackoutday.status,
			who_change: this.user.Login,
			from_status: blackoutday.status,
		};
		this.blackOutSrv.changeState(payload).subscribe((data: any)=>{
			Swal.fire(blackoutday.status, `Black Out Day ${blackoutday.status}`, 'success');
			this.getBlackOutDays();
		});
	}

	changeStatusConfirmation(blackoutday: any) {
		Swal.fire({
			title: 'Are you sure?',
			text: 'To change the status to ' + (blackoutday.status === 'Approved' ? 'Denied' : 'Approved'),
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value === true) {
				this.changeBlackOutDayStatus(blackoutday);
			}
		}).catch((err) => {});
	}

	getHistoryBlackOutDay(blackoutday: any) {
		this.historyActive = true;

		this.blackOutSrv.getBlackOutDayHistory(blackoutday.id).subscribe((data: any)=>{
			this.historyBOD = data.body;
			this.historyBlack = blackoutday;
		});
	}

	backBODs() {
		this.historyActive = false;
	}

	openAddBlackOutDay(idModal: any) {
		this.newBlackOutDay = {
			user_id: 0,
			initial_date_hour: '',
			end_date_hour: '',
			reason: '',
			status: 'Pending',
			initial_hour: '',
			initial_min: '',
			end_hour: '',
			end_min: '',
			initial_ampm: '',
			end_ampm: '',
			recurrent: null,
		};
		this.allDay = false;

		this.getAllAlias();
		this.modalService.open(idModal, { size: 'lg' }).result.then(
			(result) => {},
			(reason) => {},
		);
	}

	selectAlias(item: any) {
		this.newBlackOutDay.user_id = item.id;
	}
}
